import Errors from '@shared/error/errors';
import { routerAsync } from '@/app-module';
import Message from '@shared/message/message';
import { i18n } from '@shared/i18n';
import { IamService } from '@modules/iam/iam-service';
import ManageModel from '@shared/manage/manage-model';

const DEFAULT_USER_TEST = {
    emails: ["owqlo.test@yopmail.com"],
    firstName: 'Owlqo test',
    lastName: 'Test',
    gender: 'male',
    phoneNumber: '626223989',
}
const USE_TEST_USER = false;

export default {
    namespaced: true,

    state: {
        findLoading: false,
        saveLoading: false,
        record: USE_TEST_USER ? DEFAULT_USER_TEST : null,
    },

    getters: {
        record: (state) => state.record,
        findLoading: (state) => !!state.findLoading,
        saveLoading: (state) => !!state.saveLoading,
    },

    mutations: {
        RESET(state) {
            state.findLoading = false;
            state.saveLoading = false;

            if (!USE_TEST_USER) {
                state.record = null;
            }
        },

        FIND_STARTED(state) {
            state.record = null;
            state.findLoading = true;
        },

        FIND_SUCCESS(state, payload) {
            state.record = payload;
            state.findLoading = false;
        },

        FIND_ERROR(state) {
            state.record = null;
            state.findLoading = false;
        },

        ADD_STARTED(state) {
            state.saveLoading = true;
        },

        ADD_SUCCESS(state) {
            state.saveLoading = false;
        },

        ADD_ERROR(state) {
            state.saveLoading = false;
        },

        UPDATE_STARTED(state) {
            state.saveLoading = true;
        },

        UPDATE_SUCCESS(state) {
            state.saveLoading = false;
        },

        UPDATE_ERROR(state) {
            state.saveLoading = false;
        },
    },

    actions: {
        doNew({ commit }) {
            commit('RESET');
        },

        async doFind({ commit }, id) {

            if (!id) {
                return
            }
            try {
                commit('FIND_STARTED');

                const record = await IamService.find(id);

                commit('FIND_SUCCESS', record);
            } catch (error) {
                Errors.handle(error);
                commit('FIND_ERROR');
                routerAsync().push('/iam');
            }
        },

        async doAdd({ commit }, { values, manage }) {
            try {
                commit('ADD_STARTED');
                // create manage model
                await IamService.create(values, manage);
                commit('ADD_SUCCESS');
                Message.success(i18n('iam.doAddSuccess'));
                routerAsync().push('/iam');
            } catch (error) {
                Errors.handle(error);
                commit('ADD_ERROR');
            }
        },

        async doUpdate({ commit, rootGetters, dispatch }, { values, navigateOnSubmit = true }, ) {
            try {
                const currentManage = rootGetters['auth/manage/currentManage'];                
                commit('UPDATE_STARTED');
                await IamService.edit(values, new ManageModel(currentManage).getManageModel());

                commit('UPDATE_SUCCESS');

                const currentUser = rootGetters['auth/currentUser'];

                dispatch('property/requirements/doFetch', {
                    propertyId: currentManage.property.id,
                    userId: currentUser.id
                }, {
                    root: true
                });

                if (currentUser.id === values.id) {
                    dispatch('auth/doRefreshCurrentUser', {}, { root: true });
                }

                Message.success(i18n('iam.doUpdateSuccess'));

                if (navigateOnSubmit) routerAsync().push('/iam');
            } catch (error) {
                Errors.handle(error);
                commit('UPDATE_ERROR');
            }
        },
    },
};